import React from "react";

import { ExpandMoreRounded } from "@mui/icons-material";
import { Box, Collapse } from "@mui/material";

import { GreyPallet } from "../../config/styles";

import ExpandMore from "../ExpandMore";
import MainText from "../MainText";

import { ContainerNodeProps } from "../../types/common";

type MainCollapseBox = ContainerNodeProps & {
  title: string | JSX.Element;
  unmountOnExit?: boolean;
  show?: boolean;
  hideToggle?: boolean;
  disableToggle?: boolean;
};

export default function MainCollapseBox({
  children,
  title,
  unmountOnExit,
  show,
  hideToggle,
  disableToggle,
}: MainCollapseBox) {
  const [showContent, setShowContent] = React.useState(false);

  React.useEffect(() => {
    if (show !== undefined) setShowContent(show);
  }, [show]);

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ backgroundColor: GreyPallet.LightGhost, borderRadius: "15px" }}
        px={2}
        py={1}
        mb={1}
      >
        {typeof title === "string" ? <MainText color="regular">{title}</MainText> : title}

        {!hideToggle && (
          <ExpandMore
            expand={showContent}
            onClick={() => setShowContent(!showContent)}
            disabled={disableToggle}
            aria-expanded={showContent}
          >
            <ExpandMoreRounded />
          </ExpandMore>
        )}
      </Box>

      <Collapse
        in={showContent}
        timeout="auto"
        unmountOnExit={unmountOnExit}
        sx={{ backgroundColor: GreyPallet.LightGhost, borderRadius: "15px", overflow: "hidden" }}
      >
        <Box p={2}>{children}</Box>
      </Collapse>
    </>
  );
}
